import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgClose = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  delete other.fill;
  delete other.fillSecondary;
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.86641 2.48978L12 8.62211L18.1336 2.48978C18.7866 1.83674 19.8454 1.83674 20.4985 2.48978L21.5102 3.50153C22.1633 4.15458 22.1633 5.21337 21.5102 5.86641L15.3779 12L21.5102 18.1336C22.1633 18.7866 22.1633 19.8454 21.5102 20.4985L20.4985 21.5102C19.8454 22.1633 18.7866 22.1633 18.1336 21.5102L12 15.3779L5.86641 21.5102C5.21337 22.1633 4.15458 22.1633 3.50153 21.5102L2.48978 20.4985C1.83674 19.8454 1.83674 18.7866 2.48978 18.1336L8.62211 12L2.48978 5.86641C1.83674 5.21337 1.83674 4.15458 2.48978 3.50153L3.50153 2.48978C4.15458 1.83674 5.21337 1.83674 5.86641 2.48978Z", fill: props.fill }));
});
export default SvgClose;
